// Generated by scripts/update-seeq-icons.js from src/svg/seeq/arrow-dropdown.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcArrowDropdown = {
  prefix: 'fak',
  iconName: 'arrow-dropdown' as IconName,
  icon: [
    1024,
    1024,
    [],
    'e948',
    'M512 803.8c-25.6 0-46.1-10.2-66.6-25.6l-430-399.3c-20.5-20.5-20.5-51.2 0-71.7l66.5-71.7c20.5-20.5 51.2-20.5 71.7 0l363.5 337.9 363.5-337.9c20.5-20.5 51.2-15.4 71.7 0l56.3 71.7c20.5 20.5 15.4 51.2 0 71.7l-430 399.3c-20.5 15.4-41 25.6-66.6 25.6z',
  ],
} satisfies IconDefinition;
